module.exports = __webpack_public_path__ + "static/media/sf-test-15.ac6cad0c.mp3";